import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'dib_cookie_consent'; // 'accepted' | 'rejected'

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const choice = localStorage.getItem(STORAGE_KEY);
        if (!choice) {
            // Small delay so it doesn't fight with hero animations
            const t = setTimeout(() => setVisible(true), 700);
            return () => clearTimeout(t);
        }
    }, []);

    // Hide on admin pages
    if (location.pathname.startsWith('/admin')) return null;
    if (!visible) return null;

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, 'accepted');
        setVisible(false);
    };
    const reject = () => {
        localStorage.setItem(STORAGE_KEY, 'rejected');
        setVisible(false);
    };

    return (
        <div
            className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-[80]"
            data-testid="cookie-banner"
        >
            <div className="bg-brand-surface border border-brand-primary/60 shadow-2xl shadow-black/40 p-5 md:p-6 relative">
                <button
                    onClick={reject}
                    className="absolute top-3 right-3 text-white/40 hover:text-white transition-colors"
                    aria-label="Dismiss"
                    data-testid="cookie-banner-close"
                >
                    <X className="h-4 w-4" />
                </button>

                <div className="flex items-start gap-3">
                    <Cookie className="h-6 w-6 text-brand-primary flex-shrink-0 mt-0.5" strokeWidth={1.75} />
                    <div>
                        <div className="font-display font-black uppercase text-sm tracking-tight text-white">
                            Cookies
                        </div>
                        <p className="text-xs text-white/70 mt-1.5 leading-relaxed">
                            We use essential cookies to run this site. See our{' '}
                            <Link to="/cookies" className="text-brand-primary hover:underline">Cookie Policy</Link>{' '}
                            for details.
                        </p>
                    </div>
                </div>

                <div className="mt-4 flex gap-2">
                    <button
                        onClick={accept}
                        className="flex-1 bg-brand-primary hover:bg-brand-primaryHover text-brand-ink font-bold px-4 py-2.5 label-caps text-xs transition-colors"
                        data-testid="cookie-accept"
                    >
                        Accept
                    </button>
                    <button
                        onClick={reject}
                        className="flex-1 border border-white/20 hover:bg-white/10 text-white px-4 py-2.5 label-caps text-xs transition-colors"
                        data-testid="cookie-reject"
                    >
                        Reject
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
